import React, { useEffect, useState } from 'react'
import { Row, Col, Container } from 'react-bootstrap';
import {  useParams } from "react-router-dom";
import { getSurveyByIdAndPersonAPI } from '../api/surveyAPI';
import { SurveyItem } from '../types/index'
import SurveyFormSelect from './SurveyFormSelect';
import SurveyFormTextArea from './SurveyFormTextArea';
import SurveyFormCheckbox from './SurveyFormCheckbox';
import SurveyFormRadio from './SurveyFormRadio';
import SurveyFormInput from './SurveyFormInput';
export default function Survey() {
    const { idSurvey, order } = useParams();
    const [itemSurvey, setItemSurvey] = useState<SurveyItem | null>(null);


    useEffect(() => {
        const fetchData = async () => {
            try {
                await loadSurvey(Number(order));
            } catch (error) {
                console.error(error);

            } finally {
                console.log("loaded");
            }
        }

        fetchData()
    }, [])

    const loadSurvey = (orderParam: number) => {
        getSurveyByIdAndPersonAPI( Number(idSurvey), orderParam)
            .then(response => {
                setItemSurvey(response);
                console.log(response.description)
            })
            .catch(error => {
                console.error('Error fetching pending surveys', error);
            });

    }

    const reloadSurvey = (orderParam: number) => {
        loadSurvey(orderParam);
    };

    const renderComponent = () => {
        if (itemSurvey !== null) { 
            const idPerson = localStorage.getItem('idPersona');
            switch (itemSurvey.answers[0].valueComponent) {
                case 'SELECT':
                    return <SurveyFormSelect surveyItem={itemSurvey} idPerson={Number(idPerson)} reloadSurvey={reloadSurvey} />;
                case 'TEXTAREA':
                    return <SurveyFormTextArea surveyItem={itemSurvey} idPerson={Number(idPerson)}  reloadSurvey={reloadSurvey} />;
                case 'CHECKBOX': 
                    return <SurveyFormCheckbox surveyItem={itemSurvey} idPerson={Number(idPerson)}  reloadSurvey={reloadSurvey} />;
                case 'RADIO':
                    return <SurveyFormRadio surveyItem={itemSurvey} idPerson={Number(idPerson)}  reloadSurvey={reloadSurvey}  />;
                case 'INPUT':
                    return <SurveyFormInput surveyItem={itemSurvey} idPerson={Number(idPerson)} reloadSurvey={reloadSurvey}  />;
                default:
                    return <div></div>;
            }
        }
    };


    return (
        <>
            <Row className="d-flex flex-wrap">
                <Col className="d-flex" style={{ padding: "0" }}>
                    <Container>
                        <Row className="w-100 align-items-center" style={{ margin: "0" }}>

                            <Col xs={6} md={6} className="d-flex align-items-center" style={{ padding: "0" }}>
                                <img
                                    src="/ilustracio-craiteria-public.png"
                                    alt="Craiteria"
                                    style={{ width: '240px', height: 'auto', objectFit: 'cover', backgroundColor: '#FFF' }}
                                />
                            </Col>

                            <Col xs={6} md={6} className="d-flex flex-column h1-enquesta" >
                                {itemSurvey !== null? itemSurvey.description: "" }
                            </Col>
                        </Row>
                        <Row className="w-100 align-items-center" style={{ margin: "0" }}>
                            <Container>

                                {renderComponent()}
                                
                            </Container>
                        </Row>
                    </Container>
                </Col>
            </Row>
        </>
               
    );
}